import { FileSearch, PenLine, ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const platforms = [
  { name: "Write the Book", icon: PenLine, href: "https://app.author-pro.com/auth" },
  { name: "First Draft", icon: FileSearch, href: "https://draft.author-pro.com/app/auth" },
];

const PlatformSignIn = () => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1 pt-32 pb-20 sm:pt-40">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-12">
          <p className="eyebrow mb-4">AuthorPro</p>
          <h1 className="text-4xl sm:text-5xl font-semibold mb-4 tracking-normal">Sign In or Get Started</h1>
          <p className="text-muted-foreground">Choose a platform. New users can create their account there.</p>
        </div>
        <div className="grid gap-6 sm:grid-cols-2">
          {platforms.map(({ name, icon: Icon, href }) => (
            <article key={name} className="card-noir flex flex-col items-center p-8 text-center">
              <Icon className="h-8 w-8 text-gold mb-6" aria-hidden="true" />
              <h2 className="text-2xl font-semibold mb-8 tracking-normal">{name}</h2>
              <Button asChild className="w-full bg-gold text-gold-foreground hover:bg-gold-light font-semibold">
                <a href={href} target="_blank" rel="noopener noreferrer" aria-label={`Continue to ${name} (opens in a new tab)`}>
                  Continue <ArrowRight aria-hidden="true" />
                </a>
              </Button>
            </article>
          ))}
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default PlatformSignIn;